import Footer from "../../components/common/layout/Footer";
import DomainHero from "../../components/features/domain/DomainHero";
import DomainCarousel from "../../components/features/domain/DomainCarousel/DomainCarousel";
import HowWeWork from "@/components/features/domain/HowWeWork";
import { FAQ }  from "@/components/features/domain";
import SEO from "@/components/common/seo/seo";
import DomainTestomonial from "@/components/features/domain/DomainTestomonial";

export default function Domains() {
  return (
    <div>
      <SEO
        title="Domain Registration - SAN micron"
        description="Secure your online presence with our domain registration services. Find the perfect domain name for your business and ensure a strong digital foundation."
      />
      <DomainHero />
      {/* <div className="bg-[#f9f9f9] text-[#212121]"> */}
      <div>
        {/* <ClientLogo /> */}
        <DomainTestomonial /> 
        <HowWeWork />
        <DomainCarousel />
        <div className="abstract-bg">
          <FAQ />
        </div>
        <Footer />
      </div>
    </div>
  )
}

